<template>
  <v-container fluid class="px-0">
    <v-layout row wrap>
      <v-flex xs12>
        <p :class="[$style.headingText]">{{ lang.display_setting }}</p>
        <p v-if="!isPanel">{{ lang.display_setting_description }}</p>
      </v-flex>
    </v-layout>

    <v-responsive max-width="100%">
      <!-- サイズ -->
      <div v-if="isPanel">
        <div class="subheading">{{ lang.panel_display_size_direction }}</div>
        <v-card
          class="text-xs-center body-2 orange darken-2 pa-1 white--text"
          flat
          max-width="60"
        >
          {{ lang.hint_card_text }}
        </v-card>
        {{ lang.panel_size_hint }}
      </div>
      <div v-else>
        <div class="subheading">{{ lang.display_size }}</div>
      </div>
      <v-radio-group
        v-model="currentSizeSelect"
        @change="updateSizeSelect"
        column
        class="d-block"
      >
        <v-layout row wrap :class="$style.wrapInfoForm">
          <!-- サイズ大 -->
          <v-flex xs12 sm4 md3 lg3 class="pa-3">
            <v-layout row wrap justify-start>
              <v-flex
                xs2
                sm12
                md12
                :class="[$style.radioContainer, 'text-sm-center']"
              >
                <v-radio
                  :class="[
                    { [$style.radioPosition]: $vuetify.breakpoint.xsOnly },
                    { 'pb-1': $vuetify.breakpoint.smAndUp },
                    $style.radioContents
                  ]"
                  value="big"
                ></v-radio>
              </v-flex>
              <v-flex
                xs10
                sm12
                md12
                :class="['py-3', $style.imageBox, $style.radioGroupCursor]"
                @click="updateSizeSelect('big')"
              >
                <div
                  :class="$style.radioWrapper"
                  :style="frontCoverImageSizeBig"
                >
                  <div
                    :class="$style.imageWrapper"
                    :style="frontCoverImageSizeBig"
                  >
                    <img :class="$style.listImage" :src="frontCoverImage" />
                    <v-responsive
                      v-if="!isPanel"
                      :class="[
                        $style.embeddedImagePosition,
                        {
                          [$style.frontCoverImageRightPcBig]:
                            $vuetify.breakpoint.smAndUp &&
                            pageProgressionDirection === 'rtl',
                          [$style.frontCoverImageLeftPcBig]:
                            $vuetify.breakpoint.smAndUp &&
                            pageProgressionDirection === 'ltr',
                          [$style.frontCoverImageRightSpBig]:
                            $vuetify.breakpoint.xsOnly &&
                            pageProgressionDirection === 'rtl',
                          [$style.frontCoverImageLeftSpBig]:
                            $vuetify.breakpoint.xsOnly &&
                            pageProgressionDirection === 'ltr'
                        }
                      ]"
                      :aspect-ratio="1 / Math.sqrt(2)"
                      :style="{
                        'background-color': 'white',
                        'background-size': 'contain',
                        'background-position': 'center',
                        'background-image':
                          frontCoverType === 'simple'
                            ? 'url(' + frontCoverDefaultImage + ')'
                            : 'url(' + userFrontCoverImageUrl + ')'
                      }"
                    ></v-responsive>
                  </div>
                </div>
                <span
                  :class="{
                    [$style.displaySettingText]: $vuetify.breakpoint.smOnly
                  }"
                >
                  {{ contentsSizeText("left") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- サイズ中 -->
          <v-flex xs12 sm4 md3 lg3 class="pa-3">
            <v-layout row wrap>
              <v-flex
                xs2
                sm12
                md12
                :class="[$style.radioContainer, 'text-sm-center']"
              >
                <v-radio
                  :class="[
                    { [$style.radioPosition]: $vuetify.breakpoint.xsOnly },
                    { 'pb-1': $vuetify.breakpoint.smAndUp },
                    $style.radioContents
                  ]"
                  value="middle"
                ></v-radio>
              </v-flex>

              <v-flex
                xs10
                sm12
                md12
                :class="['py-3', $style.imageBox, $style.radioGroupCursor]"
                @click="updateSizeSelect('middle')"
              >
                <div
                  :class="$style.radioWrapper"
                  :style="frontCoverImageSizeBig"
                >
                  <div
                    :class="$style.imageWrapper"
                    :style="frontCoverImageSizeMiddle"
                  >
                    <img :src="frontCoverImage" :class="$style.listImage" />
                    <v-responsive
                      v-if="!isPanel"
                      :class="[
                        $style.embeddedImagePosition,
                        {
                          [$style.frontCoverImageRightPcMiddle]:
                            $vuetify.breakpoint.smAndUp &&
                            pageProgressionDirection === 'rtl',
                          [$style.frontCoverImageLeftPcMiddle]:
                            $vuetify.breakpoint.smAndUp &&
                            pageProgressionDirection === 'ltr',
                          [$style.frontCoverImageRightSpMiddle]:
                            $vuetify.breakpoint.xsOnly &&
                            pageProgressionDirection === 'rtl',
                          [$style.frontCoverImageLeftSpMiddle]:
                            $vuetify.breakpoint.xsOnly &&
                            pageProgressionDirection === 'ltr'
                        }
                      ]"
                      :aspect-ratio="1 / Math.sqrt(2)"
                      :style="{
                        'background-color': 'white',
                        'background-size': 'contain',
                        'background-position': 'center',
                        'background-image':
                          frontCoverType === 'simple'
                            ? 'url(' + frontCoverDefaultImage + ')'
                            : 'url(' + userFrontCoverImageUrl + ')'
                      }"
                    >
                    </v-responsive>
                  </div>
                </div>
                <span
                  :class="{
                    [$style.displaySettingText]: $vuetify.breakpoint.smOnly
                  }"
                >
                  {{ contentsSizeText("center") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- サイズ小 -->
          <v-flex xs12 sm4 md3 lg3 class="pa-3">
            <v-layout row wrap>
              <v-flex
                xs2
                sm12
                md12
                :class="[$style.radioContainer, 'text-sm-center']"
              >
                <v-radio
                  :class="[
                    { [$style.radioPosition]: $vuetify.breakpoint.xsOnly },
                    { 'pb-1': $vuetify.breakpoint.smAndUp },
                    $style.radioContents
                  ]"
                  value="small"
                ></v-radio>
              </v-flex>

              <v-flex
                xs10
                sm12
                md12
                :class="['py-3', $style.imageBox, $style.radioGroupCursor]"
                @click="updateSizeSelect('small')"
              >
                <div
                  :class="$style.radioWrapper"
                  :style="frontCoverImageSizeBig"
                >
                  <div
                    :class="$style.imageWrapper"
                    :style="frontCoverImageSizeSmall"
                  >
                    <img :src="frontCoverImage" :class="$style.listImage" />
                    <v-responsive
                      v-if="!isPanel"
                      :class="[
                        $style.embeddedImagePosition,
                        {
                          [$style.frontCoverImageRightPcSmall]:
                            $vuetify.breakpoint.smAndUp &&
                            pageProgressionDirection === 'rtl',
                          [$style.frontCoverImageLeftPcSmall]:
                            $vuetify.breakpoint.smAndUp &&
                            pageProgressionDirection === 'ltr',
                          [$style.frontCoverImageRightSpSmall]:
                            $vuetify.breakpoint.xsOnly &&
                            pageProgressionDirection === 'rtl',
                          [$style.frontCoverImageLeftSpSmall]:
                            $vuetify.breakpoint.xsOnly &&
                            pageProgressionDirection === 'ltr'
                        }
                      ]"
                      :aspect-ratio="1 / Math.sqrt(2)"
                      :style="{
                        'background-color': 'white',
                        'background-size': 'contain',
                        'background-position': 'center',
                        'background-image':
                          frontCoverType === 'simple'
                            ? 'url(' + frontCoverDefaultImage + ')'
                            : 'url(' + userFrontCoverImageUrl + ')'
                      }"
                    >
                    </v-responsive>
                  </div>
                </div>
                <span
                  :class="{
                    [$style.displaySettingText]: $vuetify.breakpoint.smOnly
                  }"
                >
                  {{ contentsSizeText("right") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- パネル用選択肢 -->
        <v-layout v-if="isPanel" row wrap :class="$style.wrapInfoForm">
          <!-- パネル大・横 -->
          <v-flex xs12 sm4 md3 lg3 class="pa-3">
            <v-layout row wrap justify-start>
              <v-flex
                xs2
                sm12
                md12
                :class="[$style.radioContainer, 'text-sm-center']"
              >
                <v-radio
                  :class="[
                    { [$style.radioPosition]: $vuetify.breakpoint.xsOnly },
                    { 'pb-1': $vuetify.breakpoint.smAndUp },
                    $style.radioContents
                  ]"
                  value="big-landscape"
                ></v-radio>
              </v-flex>
              <v-flex
                xs10
                sm12
                md12
                :class="['py-3', $style.imageBox, $style.radioGroupCursor]"
                @click="updateSizeSelect('big-landscape')"
              >
                <div :class="$style.radioWrapper" :style="panelImageSizeBig">
                  <div :class="$style.imageWrapper" :style="panelImageSizeBig">
                    <img
                      :src="panelLandscapeImage"
                      :class="[$style.listImage, $style.panelImage]"
                    />
                  </div>
                </div>
                <span
                  :class="{
                    [$style.displaySettingText]: $vuetify.breakpoint.smOnly
                  }"
                >
                  {{ contentsSizeText("left-bottom") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- パネル中・横 -->
          <v-flex xs12 sm4 md3 lg3 class="pa-3">
            <v-layout row wrap>
              <v-flex
                xs2
                sm12
                md12
                :class="[$style.radioContainer, 'text-sm-center']"
              >
                <v-radio
                  :class="[
                    { [$style.radioPosition]: $vuetify.breakpoint.xsOnly },
                    { 'pb-1': $vuetify.breakpoint.smAndUp },
                    $style.radioContents
                  ]"
                  value="middle-landscape"
                ></v-radio>
              </v-flex>

              <v-flex
                xs10
                sm12
                md12
                :class="['py-3', $style.imageBox, $style.radioGroupCursor]"
                @click="updateSizeSelect('middle-landscape')"
              >
                <div :class="$style.radioWrapper" :style="panelImageSizeBig">
                  <div
                    :class="$style.imageWrapper"
                    :style="panelImageSizeMiddle"
                  >
                    <img
                      :src="panelLandscapeImage"
                      :class="[$style.listImage, $style.panelImage]"
                    />
                  </div>
                </div>
                <span
                  :class="{
                    [$style.displaySettingText]: $vuetify.breakpoint.smOnly
                  }"
                >
                  {{ contentsSizeText("center-bottom") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- パネル小・横 -->
          <v-flex xs12 sm4 md3 lg3 class="pa-3">
            <v-layout row wrap>
              <v-flex
                xs2
                sm12
                md12
                :class="[$style.radioContainer, 'text-sm-center']"
              >
                <v-radio
                  :class="[
                    { [$style.radioPosition]: $vuetify.breakpoint.xsOnly },
                    { 'pb-1': $vuetify.breakpoint.smAndUp },
                    $style.radioContents
                  ]"
                  value="small-landscape"
                ></v-radio>
              </v-flex>

              <v-flex
                xs10
                sm12
                md12
                :class="['py-3', $style.imageBox, $style.radioGroupCursor]"
                @click="updateSizeSelect('small-landscape')"
              >
                <div :class="$style.radioWrapper" :style="panelImageSizeBig">
                  <div
                    :class="$style.imageWrapper"
                    :style="panelImageSizeSmall"
                  >
                    <img
                      :src="panelLandscapeImage"
                      :class="[$style.listImage, $style.panelImage]"
                    />
                  </div>
                </div>
                <span
                  :class="{
                    [$style.displaySettingText]: $vuetify.breakpoint.smOnly
                  }"
                >
                  {{ contentsSizeText("right-bottom") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-radio-group>
    </v-responsive>
  </v-container>
</template>

<script>
import ice from "../../../lib/ice";
import CoverDefault from "./assets/default_cover_simple.png";
import frontCoverLeft from "./assets/front_cover_left.png";
import frontCoverRight from "./assets/front_cover_right.png";
import firstPage from "./assets/first_page.png";
import secondPage from "./assets/second_page.png";
import facingPage from "./assets/facing_page.png";
import panelLandscape from "./assets/panel_landscape.png";
import panelPortrait from "./assets/panel_portrait.png";

export default {
  name: "vc-share-comic-size",
  props: {
    lang: {
      type: Object,
      default: () => ({
        display_setting: "3D表示設定",
        display_setting_description:
          "複数ページ作品は、こちらのかんたんな設定を行うことでリアルな「本」としてコンテンツを公開することができます。この設定を後から変更することはできません。",
        display_size: "本のサイズ",
        panel_display_size_direction: "パネルのサイズ・向き",
        panel_size_hint:
          "A判・B判とは異なる比率の画像でも最適なサイズで仕上がります",
        default_hybrid3d: "初期表示を3Dにする",
        set_the_spine: "背表紙を設定する",
        contents_size_doujinshi: "同人誌 (B5サイズ)",
        contents_size_book: "単行本 (B6サイズ)",
        contents_size_photo_album: "写真集 (A4サイズ)",
        contents_size_panel_big_portrait: "大 (B1サイズ・縦)",
        contents_size_panel_middle_portrait: "中 (A2サイズ・縦)",
        contents_size_panel_small_portrait: "小 (A4サイズ・縦)",
        contents_size_panel_big_landscape: "大 (B1サイズ・横)",
        contents_size_panel_middle_landscape: "中 (A2サイズ・横)",
        contents_size_panel_small_landscape: "小 (A4サイズ・横)"
      })
    },

    // state
    pageProgressionDirection: {
      type: String,
      default: "rtl"
    },
    isUploadIceContents: {
      type: Boolean,
      default: false
    },
    images: {
      type: Array,
      default: () => {
        return [{ src: "" }];
      }
    },
    iceContentsPageCount: {
      type: Number,
      default: 0
    },
    defaultThumbnailOriginalImageUrl: {
      type: String,
      default: ""
    },
    frontCoverType: {
      type: String,
      default: "simple"
    },
    isSetSpine: {
      type: Boolean,
      default: false
    },
    sizeSelect: {
      type: String,
      default: "big"
    },
    orientation: {
      type: String,
      default: "portrait"
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    userFrontCoverImageUrl: {
      type: String,
      default: ""
    },

    // mutations
    updateIsSetSpine: {
      type: Function,
      default: () => {}
    },
    updateSizeSelect: {
      type: Function,
      default: () => {}
    }
  },

  data: function() {
    return {
      frontCoverDefaultImage: CoverDefault,
      firstPageImage: firstPage,
      secondPageImage: secondPage,
      facingPageImage: facingPage,
      isIce: false,
      currentIsSetSpine: false,
      contentsSizeText1: "",
      contentsSizeText2: "",
      contentsSizeText3: "",
      isOpenSpineHelp: false,
      currentSizeSelect: "big",
      panelLandscapeImage: panelLandscape
    };
  },
  mounted: function() {
    this.isIce = ice.isIce();
  },
  methods: {
    getPageImageUrl(imageIndex) {
      // ページが存在しないときはURLを返さない
      if (this.images.length - 1 < imageIndex) {
        return "";
      }
      return this.images[imageIndex]["src"];
    },

    displaySettingEmbeddedImage(frontPageType, pagePosition) {
      let imageIndexFront = 0;
      let imageIndexRight = 0;
      let imageIndexLeft = 1;
      let defaultRightImage = "firstPageImage";
      let defaultLeftImage = "secondPageImage";

      // 1ページ目が空白の場合、製本フォーマットのため使うページが異なる(1ページ目がまだ存在しないケースのため長さチェックしている)
      if (this.images.length >= 1 && this.images[0]["src"] === undefined) {
        imageIndexFront = 1;
        imageIndexRight = 2;
        imageIndexLeft = 3;
      }

      // デフォルト表紙の場合は必ず最初の2ページを使う
      if (frontPageType === "default") {
        imageIndexRight = 0;
        imageIndexLeft = 1;
      }

      // 読み方向が逆なら左右を入れ替える
      if (this.pageProgressionDirection === "ltr") {
        imageIndexRight += 1;
        imageIndexLeft -= 1;
        defaultRightImage = "secondPageImage";
        defaultLeftImage = "firstPageImage";
      }

      // デフォルト表紙でない場合、3ページ以下の作品であれば画像URLを返さない(選択できないため)
      if (
        frontPageType !== "default" &&
        this.images.length <= 3 &&
        this.iceContentsPageCount <= 3
      ) {
        return "";
      }

      // 表紙画像が指定されたとき
      if (pagePosition === "front") {
        return this.isUploadIceContents
          ? this.defaultThumbnailOriginalImageUrl
          : this.getPageImageUrl(imageIndexFront);
      }

      // 本文画像が指定されたとき(ICEアップロードのときはユーザがアップロードした画像が参照できないため、デフォルトページ画像を返す)
      if (pagePosition === "right") {
        return this.isUploadIceContents
          ? this[defaultRightImage]
          : this.getPageImageUrl(imageIndexRight, frontPageType);
      }
      return this.isUploadIceContents
        ? this[defaultLeftImage]
        : this.getPageImageUrl(imageIndexLeft, frontPageType);
    }
  },
  computed: {
    frontCoverImageSizeBig: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return { width: "110px", height: "155px" };
        case "sm":
        default:
          return { width: "104px", height: "147px" };
      }
    },
    frontCoverImageSizeMiddle: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return { width: "100px", height: "141px" };
        case "sm":
        default:
          return { width: "90px", height: "127px" };
      }
    },
    frontCoverImageSizeSmall: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return { width: "74px", height: "104px" };
        case "sm":
        default:
          return { width: "64px", height: "90px" };
      }
    },
    panelImageSizeBig: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return { width: "155px", height: "155px" };
        case "sm":
        default:
          return { width: "147px", height: "147px" };
      }
    },
    panelImageSizeMiddle: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return { width: "141px", height: "141px" };
        case "sm":
        default:
          return { width: "121px", height: "121px" };
      }
    },
    panelImageSizeSmall: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return { width: "100px", height: "100px" };
        case "sm":
        default:
          return { width: "90px", height: "90px" };
      }
    },
    facingPageImageSize: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return { width: "150px", height: "106px" };
        case "sm":
        default:
          return { width: "160px", height: "182px" };
      }
    },
    isEnoughImages() {
      if (this.isUploadIceContents) {
        return this.iceContentsPageCount > 3;
      } else {
        return this.images.length > 3;
      }
    },
    frontCoverImage() {
      switch (this.pageProgressionDirection) {
        case "ltr":
          return frontCoverLeft;
        case "rtl":
          return frontCoverRight;
        case "single":
          return panelPortrait;
        default:
          return "";
      }
    },
    contentsSizeText() {
      return function(position) {
        if (this.isPanel) {
          switch (position) {
            case "left":
              return this.lang.contents_size_panel_big_portrait;
            case "center":
              return this.lang.contents_size_panel_middle_portrait;
            case "right":
              return this.lang.contents_size_panel_small_portrait;
            case "left-bottom":
              return this.lang.contents_size_panel_big_landscape;
            case "center-bottom":
              return this.lang.contents_size_panel_middle_landscape;
            case "right-bottom":
              return this.lang.contents_size_panel_small_landscape;
          }
        }
        switch (position) {
          case "left":
          default:
            return this.lang.contents_size_photo_album;
          case "center":
            return this.lang.contents_size_doujinshi;
          case "right":
            return this.lang.contents_size_book;
        }
      };
    }
  },
  watch: {
    isSetSpine() {
      this.currentIsSetSpine = this.isSetSpine;
    },
    sizeSelect() {
      this.currentSizeSelect = this.sizeSelect;
    }
  }
};
</script>

<style module>
.radioContainer {
  position: relative;
}

.radioContents {
  display: inline-block;
  margin: 0;
}

.radioContents > div {
  margin: 0;
}

.radioPosition {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.displaySettingText {
  display: inline-block;
  min-height: 2.9em;
}

.listImage {
  position: absolute;
  width: 100%;
  height: auto;
  top: 50%;
  left: 50%;
  min-height: 80px;
  max-width: 100%;
  max-height: 100%;
  transform: translateX(-50%) translateY(-50%);
}

.panelImage {
  min-height: 60px;
}

.imageWrapper {
  position: relative;
  margin: 0 auto;
}

.radioWrapper {
  display: flex;
  align-items: center;
  margin: 0 auto;
}

.containerBorder {
  border: solid;
}

.imageBox {
  border: solid;
  border-color: gray;
  border-radius: 10px;
  text-align: center;
  position: relative;
}

.embeddedImagePosition {
  background-size: cover;
  background-position: center;
  background-color: #ffffff;
}

.radioGroupCursor {
  cursor: pointer;
}

.frontCoverImageRightPcBig {
  position: absolute;
  top: 13px;
  left: 15px;
  width: 100%;
  height: auto;
  max-width: 78px;
}

.frontCoverImageLeftPcBig {
  position: absolute;
  top: 13px;
  left: 11px;
  width: 100%;
  height: auto;
  max-width: 77px;
}

.frontCoverImageRightSpBig {
  position: absolute;
  top: 14px;
  left: 15px;
  width: 100%;
  height: auto;
  max-width: 83px;
}

.frontCoverImageLeftSpBig {
  position: absolute;
  top: 14px;
  left: 11px;
  width: 100%;
  height: auto;
  max-width: 83px;
}

.frontCoverImageRightPcMiddle {
  position: absolute;
  top: 12px;
  left: 13px;
  width: 100%;
  height: auto;
  max-width: 68px;
}

.frontCoverImageLeftPcMiddle {
  position: absolute;
  top: 12px;
  left: 10px;
  width: 100%;
  height: auto;
  max-width: 67px;
}

.frontCoverImageRightSpMiddle {
  position: absolute;
  top: 13px;
  left: 14px;
  width: 100%;
  height: auto;
  max-width: 76px;
}

.frontCoverImageLeftSpMiddle {
  position: absolute;
  top: 13px;
  left: 10px;
  width: 100%;
  height: auto;
  max-width: 76px;
}

.frontCoverImageRightPcSmall {
  position: absolute;
  top: 8px;
  left: 10px;
  width: 100%;
  height: auto;
  max-width: 48px;
}

.frontCoverImageLeftPcSmall {
  position: absolute;
  top: 8px;
  left: 7px;
  width: 100%;
  height: auto;
  max-width: 47px;
}

.frontCoverImageRightSpSmall {
  position: absolute;
  top: 9px;
  left: 11px;
  width: 100%;
  height: auto;
  max-width: 56px;
}

.frontCoverImageLeftSpSmall {
  position: absolute;
  top: 9px;
  left: 8px;
  width: 100%;
  height: auto;
  max-width: 56px;
}

.facingPageLeftImagePc {
  position: absolute;
  top: 40px;
  left: 13px;
  width: 100%;
  height: auto;
  max-width: 65px;
}

.facingPageLeftImageSp {
  position: absolute;
  top: 6px;
  left: 12px;
  width: 100%;
  height: auto;
  max-width: 61px;
}

.facingPageRightImagePc {
  position: absolute;
  top: 40px;
  left: 82px;
  width: 100%;
  height: auto;
  max-width: 65px;
}

.facingPageRightImageSp {
  position: absolute;
  top: 6px;
  left: 77px;
  width: 100%;
  height: auto;
  max-width: 61px;
}

.leftImageNodo {
  width: 30%;
  height: 100%;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
  margin-left: auto;
}

.rightImageNodo {
  width: 30%;
  height: 100%;
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
  margin-right: auto;
}

.notEnoughImagesTextWrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
  border: solid 0;
  border-radius: 5px;
}

.notEnoughImagesTextPosition {
  position: absolute;
  top: 50%;
  width: 100%;
  height: auto;
  transform: translateY(-50%);
}

.wrapInfoForm {
  display: flex;
  justify-content: center;
}

.headingText {
  font-weight: bold;
  font-size: 16px;
}
</style>
